<template>
  <section class="border-t border-default/60 bg-default">
    <UContainer class="py-12 sm:py-14">
      <div class="mx-auto max-w-md space-y-4 text-center">
        <h2
          v-if="title"
          class="text-xl font-semibold text-highlighted"
        >
          {{ title }}
        </h2>
        <p
          v-if="subtitle"
          class="text-sm text-muted"
        >
          {{ subtitle }}
        </p>
        <form
          class="space-y-3 text-start"
          @submit.prevent="submit"
        >
          <AuthPhoneInput v-model="phone" />
          <UButton
            type="submit"
            block
            :loading="saving"
            :disabled="!canSubmit"
          >
            {{ buttonLabel || 'عضویت' }}
          </UButton>
        </form>
        <p
          v-if="done"
          class="text-sm text-primary"
        >
          عضویت شما ثبت شد.
        </p>
        <p
          v-if="error"
          class="text-sm text-error"
        >
          {{ error }}
        </p>
      </div>
    </UContainer>
  </section>
</template>

<script setup lang="ts">
import AuthPhoneInput from '~/components/auth/PhoneInput.vue'
import { isCompleteIrMobile } from '~/utils/phone'
import { apiErrorMessage } from '~/utils/apiError'

const props = defineProps<{
  title?: string
  subtitle?: string
  buttonLabel?: string
  builderPreview?: boolean
}>()

const phone = ref('')
const saving = ref(false)
const done = ref(false)
const error = ref('')
const canSubmit = computed(() => isCompleteIrMobile(phone.value) && !saving.value && !props.builderPreview)

async function submit() {
  if (!canSubmit.value) return
  saving.value = true
  error.value = ''
  try {
    const source = import.meta.client ? (sessionStorage.getItem('aradcore:campaign-source') || 'form') : 'form'
    await $fetch('/api/campaign/subscribe', {
      method: 'POST',
      body: { phone: phone.value, source, landingSlug: source !== 'form' ? source : undefined },
    })
    done.value = true
  }
  catch (err) {
    error.value = apiErrorMessage(err, 'ثبت شماره ناموفق بود')
  }
  finally {
    saving.value = false
  }
}
</script>
